// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HnMV","left":"styles_left__1cdeT","desktopActions":"styles_desktopActions__3UpCu","title":"styles_title__1efk7"};